import { util } from '@glu/core';
import FlexDropdown from '@glu/flex-dropdown';
import template from './enumSearch.hbs';
import FieldSearch from './fieldSearch';

export default FieldSearch.extend({
  template,

  regions: {
    select: '.region-enum-select'
  },

  initialize() {
    // this is a collection when using a server side enum
    this.enumHash = this.model.get('enumHash');

    // used for non-server data - should be a flat JSON object, NOT a collection
    // TODO an LOB who uses this should verify that it is working correctly
    this.enumData = util.result(this, 'enumHash');

    if (this.model.get('serverSideEnum')) {
      // if the collection already exists and has models, don't fetch again
      if (this.enumHash.models && this.enumHash.length) {
        this.enumData = this.enumHash.toJSON();
      } else {
        this.listenToOnce(this.enumHash, 'sync', this.setEnumDataAndRender);
        this.enumHash.fetch();
      }
    }
  },

  setEnumDataAndRender(enumCollection) {
    this.enumData = enumCollection.toJSON();
    this.render();
  },

  createDropdown() {
    const dropdownData = this.buildDropdownData();
    let preSelectedIds = dropdownData.length ? [dropdownData[0].id] : [];
    const value = this.model.get('value');

    if (value) {
      preSelectedIds = [value];
    }

    const dropdown = new FlexDropdown({
      data: dropdownData,
      filter: false,
      multiSelect: false,
      preSelectedIds,
      showTooltip: false,
      showCancelIcon: false,
      clearBtn: false,
      disableMultiButton: true
    });

    return dropdown;
  },

  buildDropdownData() {
    if (!this.model.get('serverSideEnum')) {
      return util.map(this.enumData, (value, key) => ({
        id: value,
        name: key || value || '' // flexdropdown checks string length on this value, cannot be undefined
      }));
    }

    // server-side enums use a collection rather than JSON
    return this.enumHash.map((model) => ({
      id: model.get('value'),
      name: model.get('label') || model.get('value') || ''
    }));
  },

  onBeforeRender() {
    this.initializeDropdown();
  },

  onRender() {
    this.showDropdown();
  },

  initializeDropdown() {
    this.closeDropdown(); // clean up the dropdown if one already exists
    this.dropdown = this.createDropdown();
  },

  showDropdown() {
    this.select.show(this.dropdown);
    this.enableSubmitButton();
  },

  enableSubmitButton() {
    const hasValue = this.dropdown.value('id').length;

    this.ui.$submitBtn.prop('disabled', !hasValue);
    this.ui.$clearBtn.toggleClass('hidden', !hasValue);
  },

  buildFilter(field, value) {
    // For enums, the label isn't the same as the selected value
    let label;

    if (this.model.get('serverSideEnum')) {
      // with server-side enums, enumHash is a collection
      const enumModel = this.model.get('enumHash').findWhere({
        value
      });
      if (enumModel) {
        label = enumModel.get('label');
      }
    } else {
      // with non-server-side enums, enumData is a name: value object
      label = util.findKey(this.enumData, (v) => v === value);
    }

    const result = {
      title: this.model.get('title'),
      value,
      label: label || value,
      type: 'enum',
      field: field || this.field,
      filter: util.bind(this.filter, this, this.field || field, value),
      enumHash: this.model.get('enumHash'),
      serverSideEnum: this.model.get('serverSideEnum'),
      format: this.model.get('format') // this is only applied to the filter for enum types
    };

    // if a formatter is defined, run it with the correct arguments
    // this would be a good place to call locale(), if needed
    if (util.isFunction(this.model.get('format'))) {
      const formatFunc = this.model.get('format');
      result.label = this.model.get('serverSideEnum') ? formatFunc(value, this.model) : formatFunc(value);
    }

    return result;
  },

  handleSubmit(e) {
    e.preventDefault();

    util.defer(() => {
      if (this.isClosed) {
        return false;
      }

      const field = this.model.get('field');
      const value = this.dropdown.value('id')[0];
      const filter = this.buildFilter(field, value);
      try {
        this.trigger('filter', filter);
      } catch (ex) {
        return false;
      }
      return false;
    });
  },

  onClose() {
    this.closeDropdown();
  },

  closeDropdown() {
    if (!this.dropdown) {
      return;
    }
    this.dropdown.close();
  }
});
